import { sbaAxios } from "../utils/sbaAxios";
import {getAssetValuations} from '../../config/apiConfig';
import {
   FETCH_POSTRETURNS_BEGIN,
   FETCH_ASSETVALUATIONS_SUCCESS,
   FETCH_POSTRETURNS_FAILURE
  } from '../constants/postReturns';


export const getAssetValuation=(entityTypeId, entityId, frequencyId, valuationDate)=> {

   return (dispatch) => {
       dispatch(fetchAssetValuationBegin());
       sbaAxios({
           url: `${getAssetValuations}${entityTypeId},${entityId},${frequencyId},${valuationDate}`,
           method: 'get',
       })
      .then((repos) => {
        const assetValuationData = repos;
        dispatch(fetchAssetValuationSuccess(assetValuationData));
        return assetValuationData;
      })
      .catch((error) => dispatch(fetchAssetValuationFailure(error)));
  };
}

export const fetchAssetValuationBegin = () => ({
  type: FETCH_POSTRETURNS_BEGIN,
});

export const fetchAssetValuationSuccess = (assetValuationData) => ({
  type: FETCH_ASSETVALUATIONS_SUCCESS,
  payload: {assetValuationData},
});


export const fetchAssetValuationFailure = (errorMessage) => ({
  type: FETCH_POSTRETURNS_FAILURE,
  payload: {errorMessage}
});

